var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconTarget(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    "data-name": "Target icon",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 216 215.95",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M107.95,179.99c-39.76,0-72.03-32.22-72.03-71.99S68.19,35.97,107.95,35.97s72.03,32.19,72.03,72.04c0,39.77-32.23,71.99-72.03,71.99M107.95,0C48.34,0,0,48.35,0,108.01s48.34,107.94,107.95,107.94,108.05-48.34,108.05-107.94S167.59,0,107.95,0Z",
    fill: "#c00",
    strokeWidth: 0
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M107.97,70.97c-20.43,0-36.99,16.52-36.99,37.01s16.56,36.99,36.99,36.99,37.04-16.57,37.04-36.99-16.59-37.01-37.04-37.01",
    fill: "#c00",
    strokeWidth: 0
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTarget);
export default __webpack_public_path__ + "static/media/Icon-Target.ec9fa382fd6907a7ad3de2af1b8a395d.svg";
export { ForwardRef as ReactComponent };